import lolcode from "refractor/lolcode";
export default lolcode;